import React from 'react';
import * as utils from "../utils";

class Summary extends React.Component {

    render() {

        if (this.props.summary !== undefined) {
            return <div className="row">
                <div className="container col-md-8 padding-bottom-5">
                    <div id="name" className="name">{this.props.summary.name}</div>
                    <div id="customerId">Fødselsnr.:{utils.formatSsn(this.props.summary.customerId)}</div>
                    <div className="text-nowrap-line timestamp-status">Usikret gjeld registrert i Gjeldsregisteret {this.props.summary.date}, klokken {this.props.summary.time}</div>
                </div>
                <div className="container col-md-4 text-center">
                </div>
            </div>
        }
        else {
            return (null);
        }
    }
}

export default Summary;